module.exports = __webpack_public_path__ + "img/4.289f1c12.png";